import { Badge, Check, Tooltip, X } from '@chain-zen/ui'

import type { TLocationSettingsType } from '../../types/tracking'

/**
 * Badge component to visualize location settings information
 */
export const LocationInfoBadge = ({
  locationInfo,
  showHealthy = true
}: {
  locationInfo: TLocationSettingsType
  showHealthy?: boolean
}) => {
  const { gpsGeolocationProviderAvailable, locationServicesEnabled } = locationInfo
  const isLocationEnabled = locationServicesEnabled === true
  const isGPSEnabled = gpsGeolocationProviderAvailable === true
  const shouldShowLocationBadge = showHealthy ? true : !isLocationEnabled
  const shouldShowGPSBadge = showHealthy ? true : !isGPSEnabled

  if (!shouldShowLocationBadge && !shouldShowGPSBadge) {
    return null
  }

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="location-info-badge">
      {/* Location Services Badge */}
      {!!shouldShowLocationBadge && (
        <Tooltip content="Whether the device's location services are turned on system-wide">
          <Badge variant={isLocationEnabled ? 'success' : 'danger'} size="xs" className="flex items-center gap-1">
            {isLocationEnabled ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}
            {`${isLocationEnabled ? 'Location enabled' : 'Location disabled'}`}
          </Badge>
        </Tooltip>
      )}

      {/* GPS Provider Badge */}
      {!!shouldShowGPSBadge && (
        <Tooltip content="Whether GPS hardware is available for precise location tracking">
          <Badge variant={isGPSEnabled ? 'success' : 'danger'} size="xs" className="flex items-center gap-1">
            {isGPSEnabled ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}
            {`${isGPSEnabled ? 'GPS enabled' : 'GPS disabled'}`}
          </Badge>
        </Tooltip>
      )}
    </div>
  )
}
